export default __webpack_public_path__ + "static/media/warning_sign.6955b4e3.svg";